import Container from '@mui/material/Container'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { BrokerSettingsHeader } from '../Views/BrokerSettings/BrokerSettingsHeader'

export const BrokerSettingsLayout = () => {
  return (
    <>
      <BrokerSettingsHeader />
      <Container maxWidth={'xl'} sx={{ px: 5, mx: 'auto' }}>
        <Outlet />
      </Container>
    </>
  )
}
